import { render, staticRenderFns } from "./SubCommunityYieldFarming.vue?vue&type=template&id=0134508b&scoped=true&"
import script from "./SubCommunityYieldFarming.vue?vue&type=script&lang=js&"
export * from "./SubCommunityYieldFarming.vue?vue&type=script&lang=js&"
import style0 from "./SubCommunityYieldFarming.vue?vue&type=style&index=0&id=0134508b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134508b",
  null
  
)

export default component.exports